import Page from "src/components/Report/Page";
import { Radar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';
import { useLocation } from "react-router-dom";

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);
export default function Page3() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");
    let jobTitle;
    if (localStorage?.data && JSON.parse(localStorage?.data)?.[jobId].baseInfo) {
        jobTitle = JSON.parse(localStorage?.data)?.[jobId].baseInfo.jobTitle;
    }
    let masouliathayeShoghli = null;
    let labels = [];
    let labelsData = [];
    if (localStorage?.data && JSON.parse(localStorage?.data)?.[jobId]?.masouliathayeShoghli) {
        masouliathayeShoghli = JSON.parse(localStorage?.data)?.[jobId]?.masouliathayeShoghli
        Object.keys(masouliathayeShoghli).map((key, index) => {
            if (masouliathayeShoghli[key].value >= 0) {
                if (key.substring(0, 25) == key) {
                    labels.push(key);
                } else {
                    labels.push(key.substring(0, 25) + "...");
                }
                labelsData.push(masouliathayeShoghli[key].value);
            }
        })
    }

    console.log(masouliathayeShoghli);


    const data = {
        labels: labels,
        datasets: [
            {
                data: labelsData,
                backgroundColor: '#1e3a8a88',
                borderColor: '#1e3a8a',
                borderWidth: 1,
            },
        ],
    };
    const options = {
        plugins: {
            legend: {
                display: false
            }
        },
        scales: {
            r: {
                pointLabels: {
                    font: {
                        size: "14px",
                        family: "iransans",
                        weight: "900"
                    }, // Adjust the font size as desired
                }
            },
            // suggestedMin: 2, // Define the minimum value for the chart
            // suggestedMax: 5,
        },
    };

    return (
        <Page pageNumber={4}>
            <div className="flex flex-col gap-3">
                <div className="font-bold text-lg">
                    مسئولیت‌ها:
                </div>
                <div className="flex w-[700px] justify-center items-center m-auto -my-24">
                    <Radar data={data} options={options} />
                </div>
                <div className="font-bold text-lg">
                    اهم مسئولیت‌های شغلی {jobTitle} عبارت است از:
                </div>
                <ul>
                    {
                        masouliathayeShoghli &&
                        Object.keys(masouliathayeShoghli).map((key, index) => {
                            if (masouliathayeShoghli[key].value >= 3) {
                                return (<li className="odd-color">{key}</li>)
                            }
                        })

                    }
                </ul>
            </div>
            <p className="rounded-lg p-4 text-justify">
                همانطور که مشخص است در این شغل ‌
                <span className="text-gray-800">
                    {masouliathayeShoghli &&
                        Object.keys(masouliathayeShoghli).sort(function (a, b) { return masouliathayeShoghli[b].value - masouliathayeShoghli[a].value }).map((key, index) => {
                            if (index < 2) {
                                return (key) + "، "
                            }
                        })}
                </span>
                از بالاترین اهمیت و ‌
                <span className="text-gray-800">
                    {masouliathayeShoghli &&
                        Object.keys(masouliathayeShoghli).sort(function (a, b) { return masouliathayeShoghli[a].value - masouliathayeShoghli[b].value }).map((key, index) => {
                            if (index < 2) {
                                return (key) + "، "
                            }
                        })}
                </span>
                از کمترین اهمیت برخوردارند.
            </p>
        </Page>
    )
}